import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "space-y-0.5"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 1,
  class: "w-4 h-4 flex-shrink-0"
};
const _hoisted_5 = {
  class: "text-sm text-slate-700 truncate"
};
const _hoisted_6 = {
  key: 0,
  class: "ml-4 border-l border-slate-200 pl-2"
};
export default {
  __name: 'DeptTree',
  props: {
    treeData: {
      type: Array,
      default: () => []
    },
    selectedDeptId: {
      type: [Number, String],
      default: null
    },
    expandedIds: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['select', 'toggle'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const handleSelect = dept => {
      emit('select', dept);
    };
    const handleToggle = dept => {
      if (dept.children?.length) {
        emit('toggle', dept.id);
      }
    };
    const onSelect = dept => {
      emit('select', dept);
    };
    return (_ctx, _cache) => {
      const _component_DeptTree = _resolveComponent("DeptTree", true);
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.treeData, dept => {
        return _openBlock(), _createElementBlock("div", {
          key: dept.id,
          class: _normalizeClass(["tree-item rounded-lg cursor-pointer", {
            'bg-primary-50': __props.selectedDeptId === dept.id
          }])
        }, [_createElementVNode("div", {
          class: "flex items-center gap-2 px-2 py-1.5",
          onClick: $event => handleSelect(dept)
        }, [dept.children?.length ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          class: _normalizeClass(["w-4 h-4 text-slate-400 transition-transform flex-shrink-0", __props.expandedIds[dept.id] ? 'rotate-0' : '-rotate-90']),
          onClick: _withModifiers($event => handleToggle(dept), ["stop"]),
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [...(_cache[1] || (_cache[1] = [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 9l-7 7-7-7"
        }, null, -1)]))], 10, _hoisted_3)) : (_openBlock(), _createElementBlock("span", _hoisted_4)), _cache[2] || (_cache[2] = _createElementVNode("svg", {
          class: "w-4 h-4 text-green-500 flex-shrink-0",
          fill: "currentColor",
          viewBox: "0 0 20 20"
        }, [_createElementVNode("path", {
          "fill-rule": "evenodd",
          d: "M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V8a2 2 0 00-2-2h-5L9 4H4zm7 5a1 1 0 00-2 0v1H8a1 1 0 000 2h1v1a1 1 0 002 0v-1h1a1 1 0 000-2h-1V9z",
          "clip-rule": "evenodd"
        })], -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(dept.name), 1)], 8, _hoisted_2), dept.children?.length && __props.expandedIds[dept.id] ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_DeptTree, {
          "tree-data": dept.children,
          "selected-dept-id": __props.selectedDeptId,
          "expanded-ids": __props.expandedIds,
          onSelect: onSelect,
          onToggle: _cache[0] || (_cache[0] = $event => emit('toggle', $event))
        }, null, 8, ["tree-data", "selected-dept-id", "expanded-ids"])])) : _createCommentVNode("", true)], 2);
      }), 128))]);
    };
  }
};